module.exports = __webpack_public_path__ + "static/media/setup-edit.7d127c2d.svg";